import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllHackathons } from "../../store/hackathonSlice";
import { NavLink } from "react-router-dom";

function Hackathons() {
  const [hackathons, setHackathons] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const getHackathonData = async () => {
      try {
        const result = await dispatch(getAllHackathons()).unwrap();
        if (result?.documents) {
          setHackathons(result.documents);
        } else {
          setHackathons(result || []);
        }
      } catch (err) {
        console.error("Failed to fetch hackathons", err);
        setHackathons([]);
      }
    };
    getHackathonData();
  }, [dispatch]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateStr).toLocaleDateString(undefined, options);
  };

  return (
    <div className="mt-32">
      <h2 className="text-3xl font-bold text-gray-800 inline-block border-b-4 border-pink-500 pb-2 mb-8">
        Hackathons
      </h2>

      {hackathons.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-20">
          <svg
            className="w-20 h-20 text-gray-400 mb-4"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8c-3 0-5 2-5 5s2 5 5 5 5-2 5-5-2-5-5-5z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 2v2m0 16v2m10-10h-2M4 12H2m16.364-7.364l-1.414 1.414M6.05 17.95l-1.414 1.414M17.95 17.95l-1.414-1.414M6.05 6.05L4.636 7.464"
            />
          </svg>
          <h3 className="text-xl font-semibold text-gray-600 mb-2">
            No hackathons to show
          </h3>
          <p className="text-gray-400 text-center max-w-sm">
            Currently, there are no hackathons available. Please check back
            later.
          </p>
        </div>
      ) : (
        hackathons.map((hackathon) => (
          <div
            key={hackathon.$id}
            className="border rounded-xl shadow-md my-6 p-6 flex flex-col justify-between hover:shadow-xl transition duration-300 bg-white hover:bg-indigo-50 border-l-4 border-indigo-500 w-full max-w-4xl mx-auto text-left"
          >
            <div>
              <h1 className="text-2xl font-bold text-indigo-700 text-center">
                {hackathon.Title}
              </h1>
              <p className="text-gray-600 mt-1 font-bold">
                {hackathon.Organizer}
              </p>

              <p className="text-gray-500 text-sm mt-1">
                <strong>Start Date: </strong> {formatDate(hackathon.startDate)}
              </p>
              <p className="text-gray-500 text-sm mt-1">
                <strong>End Date: </strong> {formatDate(hackathon.endDate)}
              </p>
              <p className="text-gray-500 text-sm mt-1">
                <strong>Mode: </strong> {hackathon.mode}
              </p>
            </div>

            <p
              className="text-gray-700 text-sm mt-3 line-clamp-3"
              dangerouslySetInnerHTML={{ __html: hackathon.description }}
            ></p>

            <div className="flex justify-end mt-4">
              <NavLink
                to={`/hackathons/${hackathon.$id}`}
                className="px-4 py-2 bg-indigo-600 text-white text-sm rounded-lg hover:bg-indigo-700 transition"
              >
                Read More
              </NavLink>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default Hackathons;
